(() => {
  "use strict";

  const initModels = section => {
    if (section.dataset.ecReady) return;
    section.dataset.ecReady = "true";
    const choices = [...section.querySelectorAll("[data-ec-model-choice]")];
    const results = [...section.querySelectorAll("[data-ec-model-result]")];
    if (!choices.length || choices.length !== results.length) return;
    const select = index => {
      choices.forEach((choice, position) => {
        const selected = position === index;
        choice.classList.toggle("is-selected", selected);
        choice.setAttribute("aria-pressed", String(selected));
      });
      results.forEach((result, position) => {
        const selected = position === index;
        result.hidden = !selected;
        result.classList.toggle("is-selected", selected);
      });
    };
    choices.forEach((choice, index) => choice.addEventListener("click", () => select(index)));
  };

  const init = scope => {
    if (scope.matches?.(".evtol-collection-models-section")) initModels(scope);
    scope.querySelectorAll?.(".evtol-collection-models-section").forEach(initModels);
  };
  init(document);
  document.addEventListener("shopify:section:load", event => init(event.target));
})();
